/** Console v0.5 Agents: the words (Agents mock-up) and which agent is live. Pure -- tested with Node. */

export const AGENTS_INTRO = "Each agent prepares one kind of work. Nothing leaves Preekie until a person approves it.";

export const AGENT_STEPS: ReadonlyArray<{ label: string; hint: string }> = [
  { label: "Requested", hint: "You or a schedule asks" },
  { label: "Prepared", hint: "The agent does the work and shows why" },
  { label: "Approved by you", hint: "The step only a person can take" },
  { label: "Lodged or sent", hint: "With a receipt kept as evidence" },
];

export const AGENTS: ReadonlyArray<{ key: string; name: string; does: string }> = [
  { key: "onboarding", name: "Onboarding", does: "Connects Xero, checks the ABN, sets up the chart of accounts and requests opening documents." },
  { key: "bookkeeping", name: "Bookkeeping", does: "Codes transactions, chases missing receipts and flags suppliers with no ABN." },
  { key: "month-end", name: "Month-end", does: "Runs the close checklist: reconciliations, accruals, payroll and the management report." },
  { key: "bas", name: "BAS", does: "Prepares BAS and IAS with a GST reconciliation and the reasons behind every adjustment." },
  { key: "r-and-d", name: "R&D evidence", does: "Captures R&D activity records as work happens. Evidence only; claims are prepared by your tax agent." },
  { key: "internal-audit", name: "Internal audit", does: "Runs ISO 27001 readiness reviews: requests evidence and maps it to Annex A controls." },
  { key: "meeting-notes", name: "Meeting notes", does: "Turns recordings into summaries, decisions and actions with owners." },
  { key: "funding", name: "Funding", does: "Gathers what a lending partner needs and tracks the request. Lending decisions are the lender's." },
];

/** Only what runs today is "Live": Meeting notes, where Meetings is on. Everything else is "Coming soon". */
export function agentState(key: string, meetingsEnabled: boolean): "Live" | "Coming soon" {
  return key === "meeting-notes" && meetingsEnabled ? "Live" : "Coming soon";
}
